
import { AppService } from "app/services/app.service";

import { AppFilter } from "app/models/app-filter.model";
import { Zona } from "app/models/zona";

export abstract class AbHorarios extends AppService {
  abstract prefixo: string;

  abstract desativar(id: number);
  abstract getAllNomeHorarios(filter: AppFilter);
  abstract getAllNomeHorariosAtivos();
  abstract saveUpdateNomeHorarios(obj: Zona);
  abstract getNomeHorarios(id: number);

}